module.exports = __webpack_public_path__ + "img/examination.61de4e1c.jpg";